import React, { useEffect, useState } from "react";
import { client, errorMessage } from "../../services";
import Loader, { Spinner } from "../../components/Loader";

// Store owners' limits and add-ons (backend routes/adminAddonPrices.js): the image storage every owner gets for all
// their websites, the emails each website gets a month, and what add-ons cost (per extra 1 GB of storage and per extra
// 1,000 emails). New limits apply at once; new prices apply to add-ons bought from now on, with the monthly plan's GST.
const formOf = (data) => ({ ...data.limits, ...data.prices });

export default function AddonPricesEditor({ notify }) {
  const [form, setForm] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    client.get("/admin/addon-prices").then(({ data }) => setForm(formOf(data))).catch((err) => setError(errorMessage(err)));
  }, []);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await client.put("/admin/addon-prices", {
        storageGb: Number(form.storageGb),
        emailsPerMonth: Number(form.emailsPerMonth),
        storage: Number(form.storage),
        email: Number(form.email),
      });
      setForm(formOf(data));
      notify(data.message);
    } catch (err) {
      notify(errorMessage(err), "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="panel info-panel">
      <h2>Limits & add-ons</h2>
      <p>What every store owner gets, and what they pay for more. New limits apply straight away; new prices apply to add-ons bought from now on (the monthly plan's GST is added on top).</p>
      {error && <div className="admin-error">{error}</div>}
      {!form && !error && <Loader label="Loading limits" />}
      {form && (
        <form className="addon-prices-form" onSubmit={save}>
          <div className="addon-prices-group">
            <h3>Limits</h3>
            <label className="admin-field">Image storage per store owner (GB)<input type="number" min="0.01" max="1000" step="0.01" value={form.storageGb} onChange={set("storageGb")} required /><small className="field-help">Shared by all of an owner's websites.</small></label>
            <label className="admin-field">Emails per website per month<input type="number" min="0" max="1000000" step="1" value={form.emailsPerMonth} onChange={set("emailsPerMonth")} required /><small className="field-help">Back to 0 on the 1st of every month.</small></label>
          </div>
          <div className="addon-prices-group">
            <h3>Add-on prices</h3>
            <label className="admin-field">Extra storage: price per 1 GB (₹)<input type="number" min="0" max="100000" step="1" value={form.storage} onChange={set("storage")} required /></label>
            <label className="admin-field">Extra emails: price per 1,000 emails (₹)<input type="number" min="0" max="100000" step="1" value={form.email} onChange={set("email")} required /></label>
          </div>
          <button className="primary-btn" disabled={busy}>{busy ? <><Spinner /> Saving</> : "Save limits & prices"}</button>
        </form>
      )}
    </div>
  );
}
